function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { Component } from "react";
import { ThemeConsumer } from "../../ThemeProvider/ThemeContext";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { carinaFontReset } from "./util/styleHelper";
import ChevronRightIcon from "../../Icon/ChevronRight";
import ChevronLeftIcon from "../../Icon/ChevronLeft";
var ItemElement = function(Component1) {
    "use strict";
    _inherits(ItemElement, Component1);
    var _super = _createSuper(ItemElement);
    function ItemElement() {
        _classCallCheck(this, ItemElement);
        return _super.apply(this, arguments);
    }
    var _proto = ItemElement.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, accessibilityLabel = _props.accessibilityLabel, accessible = _props.accessible, isRtl = _props.isRtl, testID = _props.testID, text = _props.text, disabled = _props.disabled, selected = _props.selected, onPress = _props.onPress, icon = _props.icon;
        return _jsx(ThemeConsumer, {
            children: function(theme) {
                return _jsxs("button", _objectSpread({
                    type: "button",
                    "aria-hidden": !accessible,
                    "aria-label": accessibilityLabel,
                    disabled: disabled || selected,
                    css: getPageStyles({
                        theme: theme,
                        isRtl: isRtl,
                        selected: selected
                    })
                }, injectTestId(testID), {
                    tabIndex: selected ? -1 : 0,
                    onClick: onPress,
                    "aria-current": selected,
                    children: [
                        _this.renderIcon(icon, theme, disabled),
                        text
                    ]
                }));
            }
        });
    };
    _proto.renderIcon = function renderIcon(icon, theme, disabled) {
        if (typeof icon === 'undefined') {
            return null;
        }
        if (icon === 'left') {
            return _jsx(ChevronLeftIcon, {
                size: "m",
                color: disabled ? theme.font.color.disabled : theme.font.color.soft
            });
        }
        return _jsx(ChevronRightIcon, {
            size: "m",
            color: disabled ? theme.font.color.disabled : theme.font.color.soft
        });
    };
    return ItemElement;
}(Component);
function getPageStyles(param) {
    var theme = param.theme, isRtl = param.isRtl, selected = param.selected;
    return _objectSpread({}, carinaFontReset(theme), {
        appearance: 'none',
        lineHeight: 0,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        background: 'none',
        backgroundColor: 'transparent',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: theme.size.border.radius.twoX,
        borderColor: 'transparent',
        cursor: 'pointer',
        outline: 'none',
        fontSize: theme.font.base.size.s,
        color: theme.font.color.soft,
        direction: isRtl ? 'rtl' : 'ltr',
        textAlign: 'center',
        margin: 0,
        padding: 8,
        minWidth: 16,
        position: 'relative',
        transitionProperty: 'box-shadow',
        transitionDuration: theme.animation.duration[100],
        transitionTimingFunction: theme.animation.productive.easeInOut.easing,
        svg: {
            margin: '-8px -5px',
            transform: isRtl ? 'rotate(-180deg)' : 'none'
        },
        '&:hover': {
            color: theme.font.color.hover,
            backgroundColor: theme.backgroundColor.interactive.hover,
            svg: {
                fill: theme.font.color.hover
            }
        },
        '&:active': {
            color: theme.font.color.active,
            backgroundColor: theme.backgroundColor.interactive.active,
            svg: {
                fill: theme.font.color.active
            }
        },
        '&.focus-visible': {
            boxShadow: "0 0 0 ".concat(theme.size.border.focus, "px ").concat(theme.borderColor.interactive.focus)
        },
        '&:disabled': {
            color: theme.font.color.disabled,
            fill: theme.font.color.disabled,
            pointerEvents: 'none'
        },
        '&::-moz-focus-inner': {
            border: 0,
            padding: 0
        }
    }, getCurrentPageStyles(theme, selected));
}
function getCurrentPageStyles(theme, selected) {
    if (selected) {
        return {
            borderRadius: 0,
            color: theme.font.color.base,
            pointerEvents: 'none',
            '&::before': {
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                content: '""',
                height: 4,
                backgroundColor: theme.backgroundColor.accent.fill.base,
                borderRadius: theme.size.border.radius.round
            },
            '&:hover': {
                backgroundColor: 'transparent'
            },
            '&:focus': {
                outline: 'none'
            },
            '&:disabled': {
                color: theme.font.color.base
            }
        };
    }
    return {};
}
export default ItemElement;
